import type { DeviceType } from './device-type'
import type { IPageContainer } from './page-container'

export enum NAVIGATION_GRAPH_STATUS {
  DRAFT = 'draft',
  READY = 'ready',
  STOPPED = 'stopped',
}

export interface INavigationGraphTag {
  key: string
  navigation_graph_id: string
  value: string[]
}

export type NavigationTargetToPageContainer = {
  navigation_graph_id: string
  navigation_target_key: string
  page_container_uuid: string
}

export interface INavigationGraph {
  app_key: string
  created_at: string
  created_by: string
  device_type: DeviceType
  navigation_target_to_page_container: NavigationTargetToPageContainer[]
  placement: string
  root_page_container: IPageContainer
  root_page_container_uuid: string
  status: NAVIGATION_GRAPH_STATUS
  tags: INavigationGraphTag[] | null
  title: string
  updated_at: string
  updated_by: string
  uuid: string
}

export type NavGraphFormValues = {
  appKey?: string
  deviceType?: DeviceType
  navigationTargetToPageContainer: NavigationTargetToPageContainer[]
  placement?: IOption | null
  rootPageContainer?: IPageContainer
  status: NAVIGATION_GRAPH_STATUS
  tags: INavigationGraphTag[]
  title?: string
}
